import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridStyledTagline = styling(Grid)((props) => ({
  display: "flex",
  height: "520px",
  padding: "80px 120px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "32px",
  alignSelf: "stretch",
  background:
    "radial-gradient(157.4% 100.15% at 18.33% 0%, rgba(255, 255, 255, 0.20) 25.73%, rgba(81, 42, 204, 0.20) 58.17%, rgba(255, 255, 255, 0.20) 100%), #FFF",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    height: "100%",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    alignItems: "flex-start",
  },
}));

export const GridTagline = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "24px",
  width: "100%",

  [props.theme.breakpoints.down("tablet")]: {
    alignItems: "flex-start",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  fontFamily: "Georgia",
  color: "#40249B",
  fontSize: "64px",
  fontWeight: "400",
  lineHeight: "76.8px",
  letterSpacing: "0.64px",
  textTransform: "unset",
  textAlign: "center",
  maxWidth: "748px",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.36px",
    maxWidth: "620px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
    fontSize: "32px",
    fontWeight: "400",
    lineHeight: "38.4px",
    letterSpacing: "0.32px",
    textAlign: "left",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: "Inter",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "30px",
  letterSpacing: "0.03px",
  textAlign: "center",
  whiteSpace: "pre-line",
  maxWidth: "748px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "620px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
    fontSize: "16px",
    lineHeight: "22.4px",
    textAlign: "left",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));
